import cn from 'clsx'

import { type CommunityGrid as CommunityGridType } from '../../../../../apps/benmax/src/types/sanity.types'

import Story from './Story'

import s from './CommunityGrid.module.sass'

function CommunityGrid({ title, stories }: CommunityGridType) {
    return (
        <section className={s.CommunityGrid}>
            <div className={cn(s.Cont, 'container')}>
                {title && <h1 dangerouslySetInnerHTML={{ __html: title }} />}
                <ul className={s.Stories}>{stories?.map((story, index) => <Story story={story} key={index} />)}</ul>
            </div>
        </section>
    )
}

export default CommunityGrid
